import { createSlice } from '@reduxjs/toolkit';
export var initialState = {
  countryCode: 'GB',
  currencyCode: 'GBP'
};
var _createSlice = createSlice({
    name: 'userConfiguration',
    initialState,
    reducers: {
      setDeliveryZone: function setDeliveryZone(state, _ref) {
        var payload = _ref.payload;
        if (payload) {
          state.deliveryZone = payload;
        }
      },
      setCookieConsent: function setCookieConsent(state, _ref2) {
        var payload = _ref2.payload;
        if (payload) {
          state.cookieConsent = payload;
        }
      },
      setFeatureFlags: function setFeatureFlags(state, _ref3) {
        var payload = _ref3.payload;
        if (payload) {
          state.featureFlags = payload;
        }
      },
      setRichRelevanceSessionId: function setRichRelevanceSessionId(state, _ref4) {
        var payload = _ref4.payload;
        if (payload) {
          state.richRelevanceSessionId = payload;
        }
      }
    }
  }),
  actions = _createSlice.actions,
  name = _createSlice.name,
  reducer = _createSlice.reducer;
export { actions, name, reducer };